<template>
  <v-dialog v-model="show" persistent max-width="600px" max-height="600px">
    <v-card :loading="loading" :disabled="loading">
      <v-form ref="form" @submit.prevent="sendMail">
        <v-card-title>
          <span class="headline">{{ $t('sendPlayerByMail.title') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="toValue"
                  :label="$t('sendPlayerByMail.to') + ' :'"
                  :rules="[emailRules(toValue)]"
                  required
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="objectValue"
                  :label="$t('sendPlayerByMail.object') + ' :'"
                  :rules="[objectRules(objectValue)]"
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea v-model="text" auto-grow></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" text @click="show = false">{{ $t('sendPlayerByMail.cancel') }}</v-btn>
          <v-btn color="primary" text type="submit">{{ $t('sendPlayerByMail.send') }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SendEmailDialog',

  props: {
    value: Boolean,
    from: {
      type: String,
      default: ''
    },
    shootingType: {
      type: String
    },
    username: {
      type: String,
      default: ''
    },
    userEmail: {
      type: String,
      default: ''
    },
    initialObjectValue: {
      type: String,
      default: ''
    },
    initialText: {
      type: String,
      default: ''
    },
    marketplaceProductRef: {
      type: String
    },
    videoId: {
      type: String
    }
  },

  data: () => ({
    loading: false,
    toValue: '',
    objectValue: '',
    text: ''
  }),

  computed: {
    ...mapGetters(['userId']),
    show: {
      get() {
        if (this.value) {
          this.initForm()
        }
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    emailRules(v) {
      if (!v) return this.$t('sendPlayerByMail.requiredEmail')
      if (!/.+@.+/.test(v)) return this.$t('sendPlayerByMail.formartEmail')
      return true
    },
    objectRules(v) {
      if (!v) return this.$t('sendPlayerByMail.requiredObject')
      return true
    },
    initForm() {
      this.toValue = ''
      this.objectValue = this.initialObjectValue
      this.text = this.initialText
      this.show = true
    },
    replaceCarriage(str) {
      return str.replace(/(?:\r\n|\r|\n)/g, '<br>')
    },
    async sendEmailStatistics() {
      if (this.from === 'Player') {
        if (this.shootingType === 'VIDEO') {
          await this.$store.dispatch('sharedPlayerStatistics', {
            userId: this.userId,
            marketplaceProductRef: this.marketplaceProductRef,
            data: {
              source: 'WEB',
              sharingType: 'EMAIL'
            }
          })
        }
      }

      if (this.from === 'Live' || this.from === 'LiveRooms') {
        await this.$store.dispatch('sendEmailStatsForLive', {
          userId: this.userId,
          videoId: this.videoId
        })
      }
    },
    async sendMail() {
      let body = {}

      if (this.$refs.form.validate()) {
        this.loading = true
        body.to = this.toValue
        body.subject = this.objectValue
        body.body = this.replaceCarriage(this.text)
        body.from = {
          email: this.userEmail,
          name: this.username
        }

        const res = await this.$store.dispatch('sendEmail', body)

        if (res) {
          await this.sendEmailStatistics()
          this.$mam.sendEmail(this.from)
          this.show = false
          this.$refs.form.reset()
        }

        this.loading = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.editableDiv
  height: 200px
  overflow-y: scroll
  width: 100%
  border-bottom: rgba(0, 0, 0, 0.42)
  outline: none
  color: rgb(32, 32, 32)
  font-size: 16px
</style>
